import {RouteComponentProps} from "react-router-dom";
import {InitialStateUserType} from "../../typings/state";
import React, {useEffect, useState} from "react";
import {connect, useDispatch} from "react-redux";
import { Controller, useForm } from 'react-hook-form'
import Input from '../../components/UI/Input'
import Button from '../../components/UI/Button'
import {FaTimes} from "react-icons/fa";
import { fetchProfile } from '../../redux/actions/userAction';
import {LOADING_UI, UNLOADING_UI} from "../../redux/types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {Options} from "../../typings/common";
import Select from "../../components/UI/Select";
import './profile-edit.scss'
import {BiEditAlt} from "react-icons/bi";
import axios from "axios";
import {getToken} from "../../utils/common";
import dayjs from "dayjs";
import {toast} from 'react-toastify'
const genderOptions: Options[] = [
	{
		value: 'M',
		label: 'Laki - laki',
	},
	{
		value: 'F',
		label: 'Perempuan',
	},
]
interface ProfileEditProps extends RouteComponentProps{
	user: InitialStateUserType;
	fetchProfile: Function;
}

const ProfileEdit: React.FC<ProfileEditProps> = (props) => {
	const dispatch = useDispatch();
	const profile = props.user?.profile;
	const [avatarFile, setAvatarFile] = useState<File | null>(null);
	const [avatar, setAvatar] = useState<string | null>(null);
	
	const { control, register, handleSubmit, formState: { errors }, reset } = useForm();
	
	useEffect(() => {
		// Fetch profile if not already loaded
		if (!profile) {
			props.fetchProfile();
		}
	}, [profile, props]);
	
	useEffect(() => {
		if(profile){
			reset({...profile, dob: profile.dob? new Date(profile.dob) : null})
			if(profile?.avatar){
				setAvatar(profile.avatar)
			}
		}
	},[profile, reset])
	
	useEffect(() => {
		if(avatarFile){
			setAvatar(URL.createObjectURL(avatarFile))
		}
	},[avatarFile])
	const onSubmit = async (data: any) => {
		dispatch({ type: LOADING_UI })
		const formData = new FormData();
		formData.append('fullname',data.fullname)
		formData.append('dob',data?.dob ? dayjs(data.dob).format('YYYY-MM-DD') : '')
		formData.append('gender',data.gender || '')
		formData.append('phone',data.phone || '')
		if(avatarFile){
			formData.append('avatar', avatarFile)
		}
		axios({
			url: process.env.REACT_APP_API_URL + '/profile/save',
			method: 'post',
			data: formData,
			headers: {
				"Content-Type": "multipart/form-data",
				"Authorization": `Bearer ${getToken()}`,
			},

		}).then(response => response.data).catch((err) => {
			throw err.response;
		}).then(() => {
			// Update Redux store with new profile data
			props.fetchProfile();
			toast.success("Sunting Profil Berhasil!", {
				position: toast.POSITION.TOP_CENTER
			});
		}).catch(() => {
			toast.error("Gagal menyunting profil", {
				position: toast.POSITION.TOP_CENTER
			});
		}).finally(() => {
			dispatch({ type: UNLOADING_UI })
		});
	}

	const changeAvatar = (event: any) => {
		if(event.target.files.length > 0){
			const file = event.target.files[0]
			setAvatarFile(file)
		}
	}
	const removeAvatar = () => {
		setAvatarFile(null)
	}
	return (
		<div className={'d-flex flex-column w-100'}>
			<div className={'form-wrapper'}>
				<form onSubmit={handleSubmit(onSubmit)}>
					<div className="profile-avatar flex flex-col items-center mb-4 w-full">
							<div className={'position-relative profile-avatar-image'}>
								<img src={avatar ?? 'https://placehold.co/120x120' }
								     className="rounded-full" alt='logo'/>
								{avatarFile === null && (<div className={'avatar-file'}>
									<input type="file" name={'avatar'} className={'avatar-file'} id="upload" hidden onChange={changeAvatar.bind(this)}/>
									<label htmlFor="upload">
										<BiEditAlt />
									</label>
								</div>)}
								{avatarFile && (<button className={'avatar-file-remove'} onClick={removeAvatar}>
									<FaTimes />
								</button>)}
							</div>
						</div>
						<div className="form-group mb-3">
							<label className={'form-label'}>Full Name</label>
							<Input
								placeholder='Nama Lengkap'
								name='fullname'
								register={register}
								errors={errors}
								block={true}
								rules={{
									required: "Nama Lengkap tidak boleh kosong",
								}}
							/>
						</div>
						<div className="form-group mb-3">
							<label className={'form-label'}>Email</label>
							<Input
								placeholder='Email'
								name='email'
								register={register}
								errors={errors}
								block={true}
								rules={{
									required: "Email tidak boleh kosong",
								}}
								disabled={true}
							/>
						</div>
						<div className="form-group mb-3">
							<label className={'form-label'}>Nomor Telepon</label>
							<Input
								placeholder='Nomor Telepon'
								name='phone'
								register={register}
								errors={errors}
								block={true}
								rules={{
									required: "Nomor Telepon tidak boleh kosong",
								}}
							/>
						</div>
						<div className="form-group mb-3">
							<label className={'form-label'}>Tanggal Lahir</label>
							<Controller
								control={control}
								name='dob'
								rules={{
									required: "Tanggal Lahir tidak boleh kosong",
								}}
								render={({ field }) => (
									<div className="relative">
										<DatePicker
											dateFormat="yyyy-MM-dd"
											placeholderText='Pilih Tanggal Lahir'
											onChange={(date) => field.onChange(date)}
											selected={field.value}
											className={'form-control w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200'}
											wrapperClassName="w-full"
											calendarClassName="shadow-lg border-gray-200 rounded-lg"
											locale="id-ID"
											showMonthDropdown
											showYearDropdown
											dropdownMode="select"
										/>
									</div>
								)}
							/>
							{errors?.dob && (
								<p className="text-red-600 italic mb-2">
									{String(errors?.dob?.message)}
								</p>
							)}
						</div>
						<div className="form-group mb-3">
							<label className={'form-label'}>Jenis Kelamin</label>
							<Select
								placeholder='Pilih Jenis Kelamin'
								name='gender'
								register={register}
								errors={errors}
								block={true}
								rules={{
									required: "Jenis kelamin tidak boleh kosong",
								}}
								options={genderOptions}
							/>
						</div>
						<div className="form-group mb-5">
							<Button primary block>
								Sunting
							</Button>
						</div>
				</form>
			</div>
		</div>
	)
}

const mapStateToProps = (state: any) => {
	return {
		user: state.user,
	};
};
const mapDispatchToProps = { fetchProfile };
export default connect(mapStateToProps, mapDispatchToProps)(ProfileEdit);
